<script lang="ts">
  import { isUserLoggedIn, isUserRoleWOR, isUserRoleVET, user } from "../app.store";
  import { logout } from "../app.logic";
  import { APP_TITLE } from "../utils/constants";

  let appTitle = APP_TITLE;
  let showUserMenu = true;
  $: userFullName = $user != null ? $user.fullName : "";
  $: companyName = "";
</script>

<nav class="navbar header-navbar noselect">
  <div class="container content header-content">
    <div class="navbar-brand header-brand">
      <i class="navbar-item app-logo">
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <img src="/img/logo.png" alt="Logo" />
      </i>

      {#if $isUserRoleWOR == false}
        <span class="navbar-item brand-text header-brand-text">
          {appTitle}
        </span>

        <span class="navbar-item brand-text header-brand-text">
          {companyName}
        </span>
      {/if}
    </div>

    {#if $isUserRoleWOR}
      <div class="navbar-menu">
        <div class="navbar-start">
          <a class="navbar-item" href="/butcher-entrance">Ingresso</a>
          <a class="navbar-item" href="/customer">Anagrafiche</a>
          <a class="navbar-item" href="/butcher-work/slaughter">Programma</a>
        </div>
      </div>
    {/if}

    <div class="navbar-end">
      {#if $isUserLoggedIn}
        {#if showUserMenu}
          {#if $isUserRoleVET == false}
            <a class="navbar-item header-user-name profile" href="/profile">
              {userFullName}
            </a>
          {:else}
            <span class="navbar-item header-user-name">
              {userFullName}
            </span>
          {/if}
        {/if}

        <div class="navbar-item">
          <div class="buttons">
            <button class="button is-light" on:click={logout}>
              <strong>Logout</strong>
            </button>
          </div>
        </div>
      {/if}
    </div>
  </div>
</nav>

<style>
  .header-navbar {
    /* border-bottom: 1px solid #4310a9; */
    height: 4rem;
  }

  .header-content {
    max-width: unset !important;
    padding-left: 3rem;
    /* border-bottom: 1px solid #f2f2f2; */
    display: flex !important;
    height: 100%;
  }

  .header-brand {
    flex: 1;
  }

  .header-brand-text {
    font-weight: 300;
    padding-right: 5rem;
  }

  .header-user-name {
    border: none;
  }

  .header-user-name.profile:hover,
  .header-user-name.profile:focus,
  .header-user-name.profile:focus-within {
    background-color: #ededed;
    outline: none;
  }

  .app-logo {
    /* background-color: #fafafa; */
    /* border-radius: 3rem; */
    /* width: 3rem; */
    /*height: 3rem;
    margin-top: 0.5rem;
    */
    /*width: 15rem;*/
  }

  .app-logo img {
    max-height: 3rem;
  }

  /*
  .header-brand-text:hover {
    color: #4a4a4a;
  }
  */

  .brand-text {
    font-weight: bold;
    font-size: large;
    color: #fafafa;
  }

  .header-user-name {
    font-weight: bold;
    font-size: medium;
    color: #fafafa;
  }

  .navbar-menu .navbar-item {
    color: #fafafa;
  }

  .navbar-menu .navbar-item:hover {
    color: #9e0a11;
  }
</style>
